/**
 *
 * @param fn
 * @returns {*}
 *
 * A function that assumes its first argument is a function,
 * calls that function and return the result.
 *
 * For example:
 *
 * ```
 * invoke(() => 42)
 * ```
 * ... would return `42`; And ...
 *
 * ```
 * invoke(() => {
 *   console.log("something");
 *   alert("A Alert Yo!");
 * })
 * ```
 * ... would log `something` in the console before displaying a browser alert.
 */
export const invoke = (fn: any) => fn();

/**
 *
 * @param args
 * @returns {function(*): *}
 *
 * A HOF that when given a list of arguments, returns a function that assumes
 * its first argument is a function, calls that function with the list of
 * arguments and return the result.

 * For example:

 * ```
 * const addTwoNumbers = (a, b) => a + b;
 * const invokeWithFortyAndTwo = invokeWith(4, 2);
 * invokeWithFortyAndTwo(addTwoNumbers);
 * ```
 * ... would return `6` because `4 + 2 = 6`.
 */
export const invokeWith =
  (...args: any[]) =>
  (fn: any) =>
    fn(...args);

/**
 *
 * @param functions
 * @returns {function(...[*]): *}
 *
 * Joins 2 or more methods
 */
export const joinFn =
  (functions: any) =>
  (...args: any[]) =>
    functions.forEach((fn: any) => fn(...args));
